import { __spreadArrays } from "tslib";
import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import EllipsisIcon from '../../../Icons/Ellipsis';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenu';
import { BiEventType } from '../../../biLogger';
import { useFlag } from '../../../redux/flags/hooks';
import s from './MoreMenu.scss';
var MoreMenu = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName;
    var t = useTranslation().t;
    var withArtstoreLink = useFlag('artshop_header_link');
    var items = useMemo(function () { return __spreadArrays([
        {
            key: 'groups',
            label: t('siteHeader.groups'),
            link: URLS.GROUPS,
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'groups',
                link_url: URLS.GROUPS,
            },
        },
        {
            key: 'shop',
            label: t('siteHeader.shop'),
            link: URLS.SHOP,
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'shop',
                link_url: URLS.SHOP,
            },
        },
        {
            key: 'forum',
            label: t('siteHeader.forum'),
            link: URLS.FORUM,
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'forum',
                link_url: URLS.FORUM,
            },
        }
    ], (withArtstoreLink
        ? [
            {
                key: 'artStore',
                label: (React.createElement("span", null,
                    t('siteHeader.artStore'),
                    React.createElement("img", { alt: "new", className: s['new-tag'], src: "https://st.deviantart.net/eclipse/promos/newtag.svg" }))),
                link: URLS.FORUM,
                biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_name: 'artStore',
                    link_url: URLS.FORUM,
                },
            },
        ]
        : [])); }, [t]);
    return (React.createElement(IconButtonWithContextMenu, { items: items, className: c(s['root'], className), popperClassName: s['popper'] },
        React.createElement(EllipsisIcon, { className: iconClassName, disableDefaultColors: true }),
        withArtstoreLink && React.createElement("div", { className: s['new-indicator-dot'] })));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
//# sourceMappingURL=MoreMenu.js.map